export default __webpack_public_path__ + "static/media/cover3.4681cdea.png";